import { Component, OnInit, OnDestroy, Renderer } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute }   from '@angular/router';
import { ApiService } from '../api.service';
import { specialClients } from '../appsettings';
import { hubImgUrl } from '../appsettings';
import { MdSnackBar } from '@angular/material';
import { BodyComponent } from '../body.component';

@Component({
  selector: 'app-form',
  templateUrl: './form.component.html',
  providers: [MdSnackBar],
})
export class FormComponent implements OnInit, OnDestroy {
  private sub: any;

  public form: any;
  public submitting: boolean;
  public submitted: boolean;
  public success: boolean;
  public specialClient: number;
  public specialForm: number;

  private accountId: any;
  private formId: any;
  private userId: number;
  private securityKey: string;
  private userInfos: Object;
  private dbFields: Object;
  private colorPage: string;
  private colorContent: string;
  private font: string;
  private CPgroups: any;
  private urlRedirection: any;
  private imgUrl: string;

  constructor(private router: ActivatedRoute,
              private api: ApiService,
              private titleService: Title,
              private snackBar: MdSnackBar,
              private bodyComp: BodyComponent,
              private renderer: Renderer) {
    this.imgUrl = hubImgUrl;
  };

  ngOnInit(): void {

    this.sub = this.router.queryParams.subscribe(params => {
      this.accountId = params['c'];
      this.userId = parseInt(params['u']);
      if (!this.userId) {
        this.userId = 0;
      }

      this.formId = params['f'];
      this.securityKey = params['k'];
    });

    if (specialClients[this.accountId]) {
      this.specialClient = this.accountId;
      if (~specialClients[this.accountId].indexOf(this.formId)) {
        this.specialForm = this.formId;
      }
    }

    if (!this.securityKey) {
      // md5 of secret
      this.securityKey = '3c01914f3892886852027a1899f4f18c';
    }
    if (this.securityKey === 'preview') {
      window.opener.postMessage('hubPostMessage', '*');
      this.renderer.listenGlobal('window', 'message', (event) => {
        this.treatServeDatas(JSON.parse(event.data));
      });
    } else {
      this.getForm();
    }
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }

  private treatServeDatas(result): void {

    this.form = result.form;
    this.dbFields = result.fields;
    this.userInfos = result.userInfo;
    let jsonStyle = {
        colorPage: "",
        colorContent: "",
        font: ""
    };
    if (typeof result.form != 'undefined') {
      if (typeof result.form.jsonStyle != 'undefined') {
          jsonStyle = JSON.parse(result.form.jsonStyle);
      }
      if (typeof jsonStyle.colorPage != 'undefined') {
          this.colorPage = jsonStyle.colorPage;
      }
      if (typeof jsonStyle.colorContent != 'undefined') {
          this.colorContent = jsonStyle.colorContent;
      }
      if (typeof jsonStyle.font != 'undefined') {
          this.font = jsonStyle.font;
      }
      if (typeof result.form.jsonConfirmPage != 'undefined') {
          this.CPgroups = JSON.parse(result.form.jsonConfirmPage);
      }
      else {
          this.CPgroups = [];
          this.urlRedirection= result.form.urlRedirection;
      }

      if (!this.specialClient) {
        this.bodyComp.bodyClass = 'default-theme ' + (this.form.theme || 'theme-purple');
      }

      this.form.groups = this.form.jsonForm;
      if (typeof this.form.groups === 'string') {
        this.form.groups = JSON.parse(this.form.groups);
      }

      this.titleService.setTitle(this.form.title);

      for (let group of this.form.groups) {
        if (group.isInput || group.type == 'email') {
          let type = group.type;
          group.inputType = type;
          group.type = 'input';
          if (group.autocomplete && this.userInfos) {
            group.value = this.userInfos[group.autocomplete];
          }
        }

        if (this.form.isAssociated == false) {
          if (group.preFillField && this.userInfos) {
            group.value = this.userInfos[group.autocomplete];
          }
        }

      }
    }
  }

  private getForm(): void {
    if (!this.userId)
       this.userId = 0;
    this.api.getForm(this.accountId, this.formId, this.userId, this.securityKey).then(result => {
      this.treatServeDatas(result);
    });
  }

  public checkChange(group, label, event): void {
    group.value = group.value || [];
    let index = group.value.indexOf(label);
    if (event.checked) {
      if (index === -1) {
        group.value.push(label);
      }
    } else {
      if (index !== -1) {
        group.value.splice(index, 1);
      }
    }
    if (group.value.length === 0) {
      group.value = undefined;
    }
  }

  public sendForm(value: any, valid: boolean) {
    this.submitted = true;
    if (!valid) {
      if (!this.specialClient) {
        this.snackBar.open('Formulaire invalide.', 'OK', {
          duration: 3000
        });
      }
      return false;
    }

    if(this.userId === 0 && this.securityKey == "PrevisuForHub"){
      this.success = true;
      return true;
    }

    if (this.userId === 0 && this.securityKey !== '3c01914f3892886852027a1899f4f18c' && this.form.isAssociated) {
      return false;
    }
    this.submitting = true;
    let postObject: Object = {};
    for (let group of this.form.groups) {
      let isContinue: boolean;
      let valueToPost: any;
      let other: boolean;
      switch(group.type) {
        case 'input':
          if (!group.value) {
            isContinue = true;
            break;
          }
          if (group.inputType === 'date' || group.inputType === 'datetime-local') {
            valueToPost = new Date(group.value).toISOString();
          } else {
            valueToPost = group.value;
          }
          break;
        case 'title':
          isContinue = true;
          break;
        case 'checkbox':
          if (group.hasOther) {
            let otherValue: string = 'OTHER:';
            if (group.otherValue) {
              otherValue += group.otherValue;
            }
            this.checkChange(group, otherValue, {checked: true});
          }
          if (!group.value) {
            isContinue = true;
            break;
          }
          valueToPost = group.value.toString();
          break;
        case 'select':
          if (group.value === '__OTHER__') {
            valueToPost = 'OTHER:';
            if (group.otherValue) {
              valueToPost += group.otherValue;
            }
          } else {
            valueToPost = group.value;
          }
          break;
        case 'radio':
          if (group.value === '__OTHER__') {
            valueToPost = 'OTHER:';
            if (group.otherValue) {
              valueToPost += group.otherValue;
            }
          } else {
            valueToPost = group.value;
          }
          break;
        case 'optin':
          if (group.value == 0) {
            valueToPost = 'false';
          } else {
            valueToPost = group.value;
          }
          break;
        default:
          valueToPost = group.value;
      }
      if (isContinue) {
        continue;
      }
      if (valueToPost) {
        if (this.form.isAssociated == true) {
          postObject[this.dbFields[group.main]] = valueToPost;
        } else {
          postObject[group.autocomplete] = valueToPost;
        }

        continue;
      }
    }
    this.api.postForm(this.accountId, this.formId, this.userId, this.securityKey, postObject)
      .then(result => {

        this.submitting = false;
        if(this.urlRedirection != null)
            document.location.href = this.urlRedirection;
        else
            this.success = true;
      }, error => {
        error = 'La clé unique ('+ error +') existe déjà. Merci de mettre à jour votre formulaire.';
        this.snackBar.open(error, 'OK', { duration: 3000 });
        this.submitting = false;
      }
    );
  }
  getStyleContent(): any {
      if(this.colorContent != null)
        return {"background-color" : "#"+this.colorContent};
  }
  getStylePage(): any {
      if(this.colorPage != null)
          return {"background-color" : "#"+this.colorPage};
  }
}



// WEBPACK FOOTER //
// ./src/app/form/form.component.ts